type Job<Value> = () => Promise<Value>;

export class ThrottledQueue<Value>
{
  private _capacity: number;
  private _queued_jobs: Array<Job<void>> = [];

  public constructor(capacity: number)
  {
    this._capacity = capacity;
  }

  public async run(job: Job<Value>): Promise<Value>
  {
    const token = this.enqueue(job);
    this.tryScheduleNext();
    return token;
  }

  private enqueue(job: Job<Value>): Promise<Value>
  {
    return new Promise<Value>((resolve, reject) => {
      const wrapped = () => job().then(resolve).catch(reject);
      this._queued_jobs.push(wrapped);
    });
  }

  private tryScheduleNext(): void
  {
    if (this.isFull || this._queued_jobs.length < 1) {
      return;
    }

    this.schedule(this._queued_jobs.shift());
  }

  private async schedule(job: Job<void>): Promise<void>
  {
    --this._capacity;
    await job();
    ++this._capacity;

    this.tryScheduleNext();
  }

  private get isFull(): boolean
  {
    return this._capacity < 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/utils/throttled-queue.ts